import { Tenant } from "@bonliva-crm/shared";

export function replaceEmailDomainByTenant(email: string, tenant: Tenant): string {
  // Split email into name and domain parts
  const [localPart] = email.split("@");

  const emailMap: Record<Tenant, string> = {
    [Tenant.WCC]: `${localPart}@weconnectcare.se`,
    [Tenant.BonlivaAB]: email
  };

  if (!emailMap[tenant]) {
    throw new Error(`No domain mapping found for tenant: ${tenant}`);
  }

  return emailMap[tenant];
}
